export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  // SPE Begin roles
  ACL_247 = 'ROLE_ACL_247',
  DASHBOARD_ADMIN = 'ROLE_DASHBOARD_ADMIN',
  EVENT_SIGNUP = 'ROLE_EVENT_SIGNUP',
  STOCK_ADMIN = 'ROLE_STOCK_ADMIN',
  // SPE End roles
}
